const validateMessages = {
  required: 'This field is required!',
  types: {
    email: 'This is not a valid email!',
  },
};

export default validateMessages;
